
import { get } from "app/utils/axios/kheti";
import { TreatmentTechnicalsResponse } from "../models/diagnosis";

interface GetTreatmentParams {
  diseaseId: number;
  cropId: number;
}

const getTreatmentTechnicals = async (
  params: GetTreatmentParams
) => {
  try {
    const dId = params.diseaseId ; 
    const cId = params.cropId ;  

    const response = await get<TreatmentTechnicalsResponse>(
      `/plantix/v1/disease/${dId}/crop/${cId}/treatment-technicals`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default getTreatmentTechnicals;